var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6C3.75 4.75736 4.75736 3.75 6 3.75H7.5C7.91421 3.75 8.25 3.41421 8.25 3C8.25 2.58579 7.91421 2.25 7.5 2.25H6C3.92893 2.25 2.25 3.92893 2.25 6V18C2.25 20.0711 3.92893 21.75 6 21.75H18C20.0711 21.75 21.75 20.0711 21.75 18V16.5C21.75 16.0858 21.4142 15.75 21 15.75C20.5858 15.75 20.25 16.0858 20.25 16.5V18C20.25 19.2426 19.2426 20.25 18 20.25H6C4.75736 20.25 3.75 19.2426 3.75 18V6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3C12.25 2.58579 12.5858 2.25 13 2.25H19.6555C20.8122 2.25 21.75 3.18776 21.75 4.34455V11C21.75 11.4142 21.4142 11.75 21 11.75C20.5858 11.75 20.25 11.4142 20.25 11V5.05791L12.5302 12.7777C12.2373 13.0706 11.7625 13.0706 11.4696 12.7777C11.3147 12.6228 11.2417 12.4171 11.2506 12.2143C11.2448 12.0151 11.3179 11.8141 11.47 11.6621L17.8339 5.29809C17.8928 5.23924 17.959 5.19221 18.0296 5.15701L19.4366 3.75H13C12.5858 3.75 12.25 3.41421 12.25 3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.227fd750bacc286b7f5f06219c3e5092.svg";
export { ForwardRef as ReactComponent };